import styled, { keyframes } from "styled-components";

interface MarqueeMainDivProp {
  length: number;
  itemwidth: number;
  gap: number;
  speed?: number;
}

const marqueeScroll = (distance: number) => keyframes` 
0% { transform: translateX(0px); } 
100% { transform: translateX(${distance}px); } `;

export const MarqueeMainDiv = styled.div<MarqueeMainDivProp>`
  width: 100%;
  flex: 1;
  overflow: hidden;
  .marque-scroll-list {
    list-style-type: none;
    display: flex;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    align-items: center;
    margin: 0px;
    padding: 0px;
    gap: ${(p) => p.gap}px;
    position: relative;
    flex-direction: row;
    transform: translateX(
      ${(p) => (p.gap * p.length + p.itemwidth * p.length) * -1}px
    );
    animation: ${({ gap, length, itemwidth }) =>
        marqueeScroll((gap * length + itemwidth * length) * -1)}
      ${(p) => p.speed || 10}s linear infinite;
    &:hover {
      animation-play-state: paused;
    }
  }
  &:before,
  &:after {
    width: 60px;
    content: "";

    position: absolute;
    top: 0;
    z-index: 1;
    bottom: 0;
  }
  &:before {
    left: 0;
    background: linear-gradient(90deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%);
  }
  &:after {
    right: 0;
    background: linear-gradient(270deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%);
  }
`;
